<template>
  <div class="tab flex">
    <div
      class="tab-item pointer"
      :class="{ 'tab-active': newsActiveName === index }"
      v-for="(item, index) in data"
      :key="index"
      @click="handleTypeClick(index)"
    >
      {{ item.dictLabel }}
    </div>
    <div class="more pointer" @click="moreClick">
      <span>更多</span>
      <i class="el-icon-arrow-right"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number,
      default: null,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      newsActiveName: 0,
    };
  },
  methods: {
    handleTypeClick(index) {
      this.newsActiveName = index;
      this.$emit("input", index);
      this.$emit("change");
    },
    moreClick() {
      this.$router.push({ name: "newsList" });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.tab {
  height: 48px;
  line-height: 48px;
  font-size: 18px;
  margin-bottom: 24px;
  &-item {
    padding: 0 32px;
    border-radius: 4px;
  }
  &-active {
    color: #fff;
    background: $theme-color;
  }
}
.more {
  margin-left: 24px;
  color: #999999;
  font-size: 16px;
  i {
    font-weight: bold;
    margin-left: 4px;
  }
}
</style>
